import { api } from '@/api/client';
import { useQuery } from '@tanstack/react-query';
import type { PublishedWorkflow } from '../types';

export function useWorkflows() {
  const { data, isLoading, error, refetch } = useQuery<PublishedWorkflow[], Error>({
    queryKey: ['workflows'],
    queryFn: async () => {
      const res = await api.get<{ data: PublishedWorkflow[] }>('/workflows');
      return res.data;
    },
    refetchInterval: 30_000,
    staleTime: 25_000,
  });

  return { workflows: data ?? [], isLoading, error, refetch };
}
